// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1GOzk","cell":"ColumnAccessor_cell__1uzad","firstCellAccent":"ColumnAccessor_firstCellAccent__80j7o"};